import useTopTwoOrgUnitTreeView from './UseTopTwoOrgUnitTreeView';

import TreeView from '@usas/ui-web/components/tree/TreeView';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const TopTwoOrgUnitTreeView = ({ label, name, value, error, message, selectableLeavesOnly, singleSelect,
  onChange, limitToUSASwimming = true, limitToUSASwimmingAndNCAA = false }) => {
  const { orgUnitState, options } = useTopTwoOrgUnitTreeView(limitToUSASwimming, limitToUSASwimmingAndNCAA);

  return orgUnitState.message
    ? <span className={global.LoadingMsg}>{orgUnitState.message}</span>
    : <TreeView
      label={label}
      name={name}
      value={value}
      error={error}
      message={message}
      isLoading={options.length === 0}
      options={options}
      selectableLeavesOnly={selectableLeavesOnly}
      singleSelect={singleSelect}
      onChange={onChange} />
};

export default TopTwoOrgUnitTreeView;